<template>
    <v-app>
    <Drawer current_item="menu_staff"></Drawer>
        <v-main>

            <v-banner single-line :sticky="true" style="background-color:white">
                <v-row align="end" justify="space-between">
                    <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
                        #{{ $route.params.group_id }} : {{ group_name }}
                        </v-col>
                    <v-col cols="12" md="4" align="left">
                        <v-btn v-if="permission.includes('EDIT_reservation_group_detail')" tile color="success" @click="submitChange" :disabled="!is_change" >
                            <v-icon left>mdi-check</v-icon>{{ $t('config_submit') }}
                        </v-btn>
                    </v-col>

                </v-row>
            </v-banner>

            <v-divider></v-divider>

            <v-expansion-panels class="ml-6 mr-6">

                <v-expansion-panel class="mx-auto mt-4 mr-6 pa-4">
                    <v-expansion-panel-header>{{ $t('group_description') }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <FragmentGroupDescription
                            :group_name="group_name"
                            :group_extranote="group_extranote"
                            :onchange="onchange"
                            :disabled="!permission.includes('EDIT_reservation_group_detail')"
                        ></FragmentGroupDescription>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mx-auto mt-4 mr-6 pa-4">
                    <v-expansion-panel-header>{{ $t('group_timeseat') }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <FragmentGroupTimeseat
                            :station_code="$route.params.station_code"
                            :group_id="$route.params.group_id"
                            :disabled="!permission.includes('EDIT_reservation_group_detail')"
                        ></FragmentGroupTimeseat>
                    </v-expansion-panel-content>
                </v-expansion-panel>


                <v-expansion-panel class="mx-auto mt-4 mr-6 pa-4">
                    <v-expansion-panel-header>{{ $t('group_rulepolicy') }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <FragmentGroupRulepolicy
                            :reserve_hold_by="reserve_hold_by"
                            :reserve_hold_by_items="reserve_hold_by_items"

                            :reserve_accept_by="reserve_accept_by"
                            :reserve_accept_by_items="reserve_accept_by_items"

                            :reserve_count_mode="reserve_count_mode"
                            :reserve_count_mode_items="reserve_count_mode_items"

                            :reservation_after="reservation_after"
                            :reservation_before="reservation_before"

                            :reserve_activated_callback="reserve_activated_callback"
                            :reserve_activated_callback_items="reserve_activated_callback_items"

                            :appointment_aftermin="appointment_aftermin"
                            :appointment_beforemin="appointment_beforemin"
                            :appointment_aftermin_type="appointment_aftermin_type"
                            :appointment_beforemin_type="appointment_beforemin_type"

                            :reservation_aftermin="reservation_aftermin"
                            :reservation_beforemin="reservation_beforemin"
                            :reservation_aftermin_type="reservation_aftermin_type"
                            :reservation_beforemin_type="reservation_beforemin_type"

                            :reserve_month_dup_day="reserve_month_dup_day"
                            :reserve_month_dup_week="reserve_month_dup_week"
                            :reserve_month_dup_month="reserve_month_dup_month"
                            :reserve_month_dup_all="reserve_month_dup_all"

                            :reserve_calendar_startdate="reserve_calendar_startdate"
                            :reserve_calendar_enddate="reserve_calendar_enddate"

                            :reserve_enable_startdate="reserve_enable_startdate"
                            :reserve_enable_enddate="reserve_enable_enddate"

                            :onchange="onchange"
                            :disabled="!permission.includes('EDIT_reservation_group_detail')"
                        ></FragmentGroupRulepolicy>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="mx-auto mt-4 mr-6 pa-4">
                    <v-expansion-panel-header>{{ $t('group_extrafield') }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <FragmentGroupExtranote
                            :onchange="onchange"
                            :extranote_list="extranote_list"
                            :disabled="!permission.includes('EDIT_reservation_group_detail')"
                        ></FragmentGroupExtranote>
                    </v-expansion-panel-content>
                </v-expansion-panel>

            </v-expansion-panels>
        </v-main>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
import FragmentGroupDescription from '@/components/AppointmentGroup/FragmentGroupDescription.vue'
import FragmentGroupRulepolicy from '@/components/AppointmentGroup/FragmentGroupRulepolicy.vue'
import FragmentGroupTimeseat from '@/components/AppointmentGroup/FragmentGroupTimeseat.vue'
import FragmentGroupExtranote from '@/components/AppointmentGroup/FragmentGroupExtranote.vue'

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
    components: {
        Drawer
        ,FragmentGroupDescription
        ,FragmentGroupRulepolicy
        ,FragmentGroupTimeseat
        ,FragmentGroupExtranote
    },
    data () {
        return {

            group_name:"",
            group_extranote:"",

            reserve_hold_by : {name:"",desc:"",val:""},
            reserve_hold_by_items: [
                {name:this.$i18n.t('reserve_hold_by_user_staff_name'),desc:this.$i18n.t('reserve_hold_by_user_staff_desc'),val:'user_staff'}
                ,{name:this.$i18n.t('reserve_hold_by_staff_only_name'),desc:this.$i18n.t('reserve_hold_by_staff_only_desc'),val:'staff_only'}
            ],
            reserve_accept_by : {name:"",desc:"",val:""},
            reserve_accept_by_items: [
                {name:this.$i18n.t('reserve_accept_by_staff_name'),desc:this.$i18n.t('reserve_accept_by_staff_desc'),val:'staff'}
                ,{name:this.$i18n.t('reserve_accept_by_auto_name'),desc:this.$i18n.t('reserve_accept_by_auto_desc'),val:'auto'}
            ],
            reserve_count_mode : {name:"",desc:"",val:""},
            reserve_count_mode_items: [
                {name:this.$i18n.t('reserve_count_mode_hold_accept_name'),desc:this.$i18n.t('reserve_count_mode_hold_accept_desc'),val:'hold_accept'}
                ,{name:this.$i18n.t('reserve_count_mode_accept_name'),desc:this.$i18n.t('reserve_count_mode_accept_desc'),val:'accept'}
            ],
            reservation_after : "",
            reservation_before : "",
            reserve_activated_callback : {name:"",desc:"",val:"",attr:""},
            reserve_activated_callback_items: [
                {name:this.$i18n.t('reserve_activated_callback_none_name'),desc:this.$i18n.t('reserve_activated_callback_none_desc'),val:'none'}
                //,{name:this.$i18n.t('reserve_activated_callback_hyq_epr_name'),desc:this.$i18n.t('reserve_activated_callback_hyq_epr_desc'),val:'hyq_epr'}
                ,{name:this.$i18n.t('reserve_activated_callback_call_wait_name'),desc:this.$i18n.t('reserve_activated_callback_call_wait_desc'),val:'call_wait'}
                ,{name:this.$i18n.t('reserve_activated_callback_pattaya_feedback_name'),desc:this.$i18n.t('reserve_activated_callback_pattaya_feedback_desc'),val:'pattaya_feedback'}
            ],
            appointment_aftermin : "",
            appointment_beforemin : "",
            appointment_aftermin_type : "",
            appointment_beforemin_type : "",

            reservation_aftermin : "",
            reservation_beforemin : "",
            reservation_aftermin_type : "",
            reservation_beforemin_type : "",

            reserve_month_dup_day : "",
            reserve_month_dup_week : "",
            reserve_month_dup_month : "",
            reserve_month_dup_all : "",

            reserve_calendar_startdate : "",
            reserve_calendar_enddate : "",

            reserve_enable_startdate : "",
            reserve_enable_enddate : "",

            extranote_list : [],
            old_extranote_list : [],

            change_list : {},
            is_change : false
            ,permission : []
        }
    },
    mounted: function () {
        var que = this.$store.commit('addLoading')
        this.permission = Staff.getPermission('AppointmentGroupDetail',this.$route.params.station_code).then(permission=>{
            console.log(permission)
            this.permission = permission
            this.$store.commit('finishLoading',que)
        })
        this.reload()
    },
    methods: {
      reload () {

        this.is_change = false
        this.change_list = {}

        var que1 = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.appointment.group.get_groupdetail
            ,{station_code:this.$route.params.station_code,group_id:this.$route.params.group_id}
            ,{ headers: Staff.getTokenHeader()}
        ).then(response => {
            
            this.group_name = response.data.group_name
            this.group_extranote = response.data.group_extranote

            this.$store.commit('finishLoading',que1)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })

        var que2 = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.appointment.group.get_grouprulepolicy
            ,{station_code:this.$route.params.station_code,group_id:this.$route.params.group_id}
            ,{ headers: Staff.getTokenHeader()}
        ).then(response => {
            
            this.reserve_hold_by_items.forEach(i=>{
                if(i.val == response.data.reserve_hold_by ) {
                    this.noti_reserve_hold_by = i.val
                    this.reserve_hold_by = i
                }
            })
            this.reserve_accept_by_items.forEach(i=>{
                if(i.val == response.data.reserve_accept_by ) {
                    this.reserve_accept_by = i
                    this.noti_reserve_accept_by = i.val
                }
            })
            this.reserve_count_mode_items.forEach(i=>{
                if(i.val == response.data.reserve_count_mode ) this.reserve_count_mode = i
            })
            this.reservation_after = response.data.reservation_after
            this.reservation_before = response.data.reservation_before
            this.reserve_activated_callback_items.forEach(i=>{
                if(i.val == response.data.reserve_activated_callback ) this.reserve_activated_callback = i
            })
            this.appointment_aftermin = response.data.appointment_aftermin
            this.appointment_beforemin = response.data.appointment_beforemin
            this.appointment_aftermin_type = 'min'
            this.appointment_beforemin_type = 'min'

            this.reservation_aftermin = response.data.reservation_aftermin
            this.reservation_beforemin = response.data.reservation_beforemin
            this.reservation_aftermin_type = 'min'
            this.reservation_beforemin_type = 'min'

            this.reserve_month_dup_day = response.data.reserve_month_dup_day
            this.reserve_month_dup_week = response.data.reserve_month_dup_week
            this.reserve_month_dup_month = response.data.reserve_month_dup_month
            this.reserve_month_dup_all = response.data.reserve_month_dup_all

            this.reserve_calendar_startdate = response.data.reserve_calendar_startdate
            this.reserve_calendar_enddate = response.data.reserve_calendar_enddate

            this.reserve_enable_startdate = response.data.reserve_enable_startdate
            this.reserve_enable_enddate = response.data.reserve_enable_enddate


            this.$store.commit('finishLoading',que2)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })

        var que3 = this.$store.commit('addLoading')
        axios
        .post(config.api.url.public.appointment.get_groupextranotelist
            ,{ group_id:this.$route.params.group_id }
        ).then(response => {
            
            this.extranote_list = response.data
            this.old_extranote_list = []
            this.extranote_list.forEach(e=>{
                this.old_extranote_list.push({
                    extranote_name : e.extranote_name
                    ,extranote_label : e.extranote_label
                    ,extranote_value : e.extranote_value
                })
            })
            

            this.$store.commit('finishLoading',que3)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })

      },
      onchange(field,val) {
        let isChange = false;

        if(['reserve_hold_by','reserve_accept_by','reserve_count_mode','reserve_activated_callback'].includes(field)){
            if(val.val != this[field].val){
                isChange = true;
                this.change_list[field] = {
                    field : field
                    ,toid : this.$route.params.station_code
                    ,params : {
                        group_id : this.$route.params.group_id
                        ,setting_tag : field
                        ,setting_value : val.val
                    }
                }

                if(field=='reserve_hold_by'){
                    this.noti_reserve_hold_by = val.val
                }else if(field=='reserve_accept_by'){
                    this.noti_reserve_accept_by = val.val
                }
            }
        }
        /*else if(field = 'reserve_activated_callback'){
            if(index=0){
                if(val.val != this[field].val){
                    isChange = true;
                    this.change_list[field] = {
                        field : field
                        ,toid : this.$route.params.station_code
                        ,params : {
                            station_code : this.$route.params.station_code
                            ,setting_tag : field
                            ,setting_value : val.val
                        }
                    }
                }
            }else if(index=1){
                if(val != this[field].attr){
                    isChange = true;
                    this.change_list[field] = {
                        field : field
                        ,toid : this.$route.params.station_code
                        ,params : {
                            station_code : this.$route.params.station_code
                            ,setting_tag : field
                            ,setting_value : val.val
                        }
                    }
                }else if(){

                }
            }
        }*/
        else if(field=='extranote_list'){

            console.log(this.old_extranote_list)
            var isExtranotChange = false
            if(this.old_extranote_list.length != val.length){
                isExtranotChange = true;
            }else{
                this.old_extranote_list.forEach((e,i)=>{
                    if(e.extranote_name != val[i].extranote_name
                     || e.extranote_label != val[i].extranote_label
                      || e.extranote_value != val[i].extranote_value
                    ){
                        isExtranotChange = true
                    }
                })
            }

            if(isExtranotChange){
                isChange = true;
                this.change_list[field] = {
                    field : field
                    ,toid : this.$route.params.station_code
                    ,params : {
                        group_id : this.$route.params.group_id
                        ,setting_tag : field
                        ,setting_value : val
                    }
                }
            }
        }
        else if(val != this[field]){
            isChange = true;
            this.change_list[field] = {
                field : field
                ,toid : this.$route.params.station_code
                ,params : {
                    group_id : this.$route.params.group_id
                    ,setting_tag : field
                    ,setting_value : val
                }
            }
        }

        if(!isChange){
            delete this.change_list[field];
        }
        this.is_change = Object.keys(this.change_list).length > 0
      },
      submitChange(){
        var que = this.$store.commit('addLoading')
        var change_data = [];
        Object.keys(this.change_list).forEach(k=>{
            change_data.push(this.change_list[k]);
        });
        axios
        .post(config.api.url.manage.save.config,{editlist:change_data},{ headers: Staff.getTokenHeader()})
        .then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        }).catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
      }
    }
}
</script>